import { I18nt } from 'utils';
import styles from './ExamenBox.module.less';
import { useExamenesLabCtx } from '../../ExamenesLabContext';
import {
	CheckCircleOutlined,
	ClockCircleOutlined,
	SyncOutlined,
} from '@ant-design/icons';
import { ConsultaExamen } from 'utils/interfaces';
import { Button } from 'antd';

const ExamenBox = ({ examen }: { examen: ConsultaExamen }) => {
	const { getResultados } = useExamenesLabCtx();
	const [examenesPendientes] = examen.cantExamenes.split('/');

	const stateMap = () => {
		if (examen.estadoSTR === 'En Espera') {
			return (
				<div className={styles.scheduled}>
					<ClockCircleOutlined />
					<p>{I18nt('en_espera')}</p>
				</div>
			);
		}
		if (examen.estadoSTR === 'Completado') {
			return (
				<div className={styles.completed}>
					<CheckCircleOutlined />
					<p>{I18nt('completo')}</p>
				</div>
			);
		}
		if (examen.estadoSTR === 'En Proceso') {
			return (
				<div className={styles.progress}>
					<SyncOutlined />
					<p>{I18nt('en_progreso')}</p>
				</div>
			);
		}
	};

	return (
		<div className={styles.citaBox}>
			<div className={styles.mobileStateBox}>
				<div className={styles.mobileCreated}>
					<p>{`${I18nt('emitido_el')} ${examen.fechaEmision}`}</p>
				</div>
				<div className={styles.mobileState}>{stateMap()}</div>
			</div>
			<div className={styles.borderBox}>
				<div className={styles.place}>
					<p>{`${I18nt('lugar')}:`}</p>
					<p>{examen.laboratorio}</p>
				</div>
				<div className={styles.doctor}>
					<p>{`${I18nt('medico')}:`}</p>
					<p>{examen.medico || I18nt('general')}</p>
				</div>
				<div className={styles.specialty}>
					<p className={examen.medico ? styles.specialDr : styles.generalDr}>
						{examen.medico ? examen.especialidad : I18nt('general')}
					</p>
				</div>
				<div className={styles.examenes}>
					<p>{`${I18nt('examenes')}:`}</p>
					<p>{examen.cantExamenes}</p>
				</div>
				<div className={styles.state}>{stateMap()}</div>
				<div className={styles.emision}>
					<p>{`${I18nt('emision')}:`}</p>
					<p>{examen.fechaEmision}</p>
				</div>
				<div className={styles.seeDetails}>
					<Button
						disabled={examenesPendientes === '0'}
						type='link'
						onClick={() => getResultados(examen)}
					>
						{I18nt('ver_examenes')}
					</Button>
				</div>
			</div>
		</div>
	);
};

export default ExamenBox;
